/**
 * Single source of truth for the enabled-models contract (Agion#1847).
 *
 * `enabled_models` on a provider is the organization's explicit selection of
 * models made available for governed use. An EMPTY list means NO models are
 * selectable; it is never an implicit "all models" wildcard. The backend
 * enforces the same contract when admitting model selections (model admission
 * reads discovered-deployment lifecycle rows, not the provider catalog), so a
 * UI surface that widens an empty list to the full catalog offers models the
 * platform rejects at save time.
 *
 * Matching is exact or case-insensitively exact; never substring.
 */
export function isEnabledModel(
  enabledModels: string[] | undefined | null,
  modelId: string
): boolean {
  if (!enabledModels || enabledModels.length === 0) return false;
  return enabledModels.some(
    (enabled) => modelId === enabled || modelId.toLowerCase() === enabled.toLowerCase()
  );
}
